import { Button } from '@/components/ui/button'
import { NotificationBell } from '@/components/ui/NotificationBell'
import { useAuth } from '@/contexts/AuthContext'
import { Settings, LogOut } from 'lucide-react'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { useNavigate } from 'react-router-dom'
import { useHeaderActions } from '@/contexts/HeaderActionsContext'
import { IS_DEMO_MODE } from '@/config/config'

export const AppHeader = () => {
    const { userProfile, signOut } = useAuth()
    const navigate = useNavigate()
    const ctx = useHeaderActions()

    const handleSignOut = async () => {
        try { await signOut() } catch {}
        navigate('/login', { replace: true })
    }

    return (
        <div className="flex items-center gap-1">
            <NotificationBell onNavigateToNote={ctx?.onNavigateToNote} />

            {userProfile?.is_admin && (
                <DropdownMenu.Root>
                    <DropdownMenu.Trigger asChild>
                        <Button variant="outline" size="icon">
                            <Settings className="h-4 w-4" />
                        </Button>
                    </DropdownMenu.Trigger>
                    <DropdownMenu.Portal>
                        <DropdownMenu.Content
                            className="min-w-[200px] bg-white rounded-md border border-gray-200 shadow-lg p-1 z-50"
                            sideOffset={5}
                        >
                            <DropdownMenu.Item
                                className="flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded cursor-pointer outline-none"
                                onClick={() => ctx?.onNavigate('csv_uploader')}
                            >
                                Import XLSX
                            </DropdownMenu.Item>
                            <DropdownMenu.Item
                                className="flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded cursor-pointer outline-none"
                                onClick={() => ctx?.onNavigate('manage_team')}
                            >
                                Gestion d'équipe
                            </DropdownMenu.Item>
                            <DropdownMenu.Item
                                className="flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded cursor-pointer outline-none"
                                onClick={() => ctx?.onNavigate('legacy_notes')}
                            >
                                Import Legacy Notes
                            </DropdownMenu.Item>
                            <DropdownMenu.Separator className="my-1 border-t border-gray-100" />
                            <DropdownMenu.Item
                                className="flex items-center px-3 py-2 text-sm text-red-600 hover:bg-red-50 rounded cursor-pointer outline-none"
                                onClick={() => ctx?.onNavigate('clear_test_data')}
                            >
                                Clear Test Data
                            </DropdownMenu.Item>
                        </DropdownMenu.Content>
                    </DropdownMenu.Portal>
                </DropdownMenu.Root>
            )}

            {IS_DEMO_MODE ? (
                <span className="px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap bg-amber-100 text-amber-800 border border-amber-200">
                    Démo, lecture seule
                </span>
            ) : (
                <Button onClick={handleSignOut} variant="outline" size="icon">
                    <LogOut className="h-4 w-4" />
                </Button>
            )}
        </div>
    )
}
